import React, { useEffect, useRef, useState } from 'react';

import './groups.css';
import EntryData from '../../services/entry-service';
import SocioData from '../../services/socio-service';
import PeopleData from '../../services/people-service';
import { useParams } from 'react-router-dom';


export class Tile extends React.Component {
    render() {
      let bgColor = "white";
      let content = "";
      if( this.props.selections ){
        for (var i = 0; i < this.props.selections.length; i++ ){
          if( this.props.selections[i] === this.props.id ){
            if( this.props.match )
              bgColor = "green";
            else
              bgColor = "red";
          }
        }
      }
      if( this.props.favourite ){
        content = '\u2605';
      }
      // don't set a background colour if no selection is found (red/green)
      if( bgColor == "white" )
        return (<td></td>);

      return (
      <td style={{backgroundColor: bgColor}}>
          <div style={{color: "yellow", fontSize: 20}}>{content}</div>
      </td>
      );
    }

    filterUsers(user,data){
      //console.log("Filtering for user: " + user);
      return data.filter(
        function(data){ return data.personID == user }
      );
    }
}
  
export class Sociogram extends React.Component {
  
    render() {
      let data = this.props.data;

      console.log("Checking SocioGram Group Data");
      console.log(data);

      let rows = [];
      let namesRow = [];
      let popularityRow = [];

      // first cell is empty
      namesRow.push(<td><b>{this.props.groupName}</b></td>);

      // label the popularity row
      popularityRow.push(<td><b>Popularity</b></td>);

      for (var i=0; i < data.length; i++) {
        namesRow.push(<td className="rotateText">
          {data[i].personName}
        </td>);
      }

      namesRow.push(<td>Mutual Count</td>);

      rows.push(<tr>{namesRow}</tr>);

      var mutualCount = 0;
      var popularityCount = {};

      for (var i=0; i < data.length; i++) {
        if( data[i]["selection"] ) {
					for( var selectedUsersCount = 0; selectedUsersCount < data[i].selection.length; selectedUsersCount++ ){
						if( !popularityCount[data[i].selection[selectedUsersCount]] ){
							popularityCount[data[i].selection[selectedUsersCount]] = 1;
						} else {
							popularityCount[data[i].selection[selectedUsersCount]] = popularityCount[data[i].selection[selectedUsersCount]] + 1;
						}
					}
        }
        //console.log("Status: " + JSON.stringify(popularityCount));
        var squares = [];   
        for (var x=0; x < data.length; x++) {
          var match = false;
          var favourite = false;
          // if data[i] (vertical user) favourite matches horizontal user( data[x]), mark as favourite
          if( data[i].favourite === data[x].personID ){
            favourite = true;
          }
          if( data[i]["selection"] ) {
            for (var y = 0; y < data[i].selection.length; y++ ){
              if( data[x]["selection"] ) {
                for (var z = 0; z < data[x].selection.length; z++ ){
                  if( data[i].selection[y] === data[x].personID && data[x].selection[z] === data[i].personID){
                    mutualCount++;
                    match = true;
                  }
                }
              }
            }
          }
          squares.push(<Tile id={data[x].personID} id2={data[i].personID} selections={data[i].selection} parentSelections={data[x].selection} match={match} favourite={favourite} />);
        }
        squares.push(<td>{mutualCount}</td>);
        // vertical column for names follows by socio values
        rows.push(<tr className="board-row">
          <td className="name-cell-horizontal">
            {data[i].personName}
          </td>
          {squares}
        </tr>);

        mutualCount = 0;
      }

      for (var i=0; i < data.length; i++) {
        popularityRow.push(<td>
          {popularityCount[data[i].personID]}
        </td>);
      }
      rows.push(popularityRow);
      ////console.log("Popularity: " + JSON.stringify(popularityCount));


      return (
        <table>
          <tbody>
            {rows}
          </tbody>
        </table>
      );
    }
}
  
export const SocioGroupRender = ({ accessToken }) => {
  // Use the useParams hook to get the id parameter from the URL
  const { id, size } = useParams();

  // Set up state with useState hook
  const [state, setState] = useState({
    entries: [],
    sociogram: null,
    people: [],
    data: null
  });

  // Replace componentDidMount with useEffect
  useEffect(() => {
    // Create an async function inside useEffect
    const fetchData = async () => {
      try {
        // Get entries
        const entries = await EntryData.getEntriesBySociogram(id, accessToken);
        setState(prevState => ({
          ...prevState,
          entries
        }));

        // Get sociogram data
        const sociogramData = await SocioData.getSociogram(id, accessToken);
        
        // Update sociogram in state
        setState(prevState => ({
          ...prevState,
          sociogram: sociogramData
        }));

        // Get people data
        const peopleData = await PeopleData.queryData(sociogramData.people, accessToken);
        sociogramData.people = peopleData;

        // Update sociogram in state
        setState(prevState => ({
          ...prevState,
          sociogram: sociogramData
        }));
        
        // Generate sociogram JSON
        const sociogramMainData = produceSociogramJSON(peopleData, entries);

        // produce a new JSON object which creates groups based on the provided size
        var groupedSociogramJSON = produceGroupedSociogramJSON(sociogramMainData, size);

        // Update state with people and data
        setState(prevState => ({
          ...prevState,
          people: peopleData,
          data: groupedSociogramJSON
        }));

        let sociograms = [];
        if ( groupedSociogramJSON ) {
          for (var i=0; i < groupedSociogramJSON.length; i++) {
            sociograms.push(<div>      
              <div className="game">
                { groupedSociogramJSON &&
                  <Sociogram data={groupedSociogramJSON[i]} groupName={"Group " + (i + 1)} />
                }
              </div>
            </div>);
          }
          // Update state with people and data
          setState(prevState => ({
            ...prevState,
            sociograms
          }));
        }
      } catch (error) {
        console.error("Error loading sociogram data:", error);
      }
    };

    if (id && accessToken) {
      fetchData();
    }
    
    // Dependencies array - re-run when id or accessToken changes
  }, []);
    
    return (
      <div>
        {state.sociograms}
      </div>
    );
}

// Move static methods outside to make them available to the component
// These could also be moved to a utility file if needed
  export const produceSociogramJSON = (people,entries) => {
    const sociogramBody = [];
  
    for (let personCount = 0; personCount < people.length; personCount++) {
      const person = people[personCount];
      const item = {
        personID: person.id,
        personName: person.givenName + " " + person.surname,
        selection: findEntrySelectionsByPersonID(person.id, entries),
        favourite: findEntryFavouriteByPersonID(person.id, entries)
      };
      
      sociogramBody.push(item);
    }
    
    return sociogramBody;
  }

  export const produceGroupedSociogramJSON = (sociogramJSON, groupSize) => {
    var groupSizeNumber = Number(groupSize);
    // round up the group count
    var groupCount = Math.ceil(sociogramJSON.length / groupSizeNumber);
    console.log("Group Count: " + groupCount);

    // use this to store the entries that have been assigned to a group
    var assigned = [];
    var sociogramGroups = [];

    console.log("Randomly select people to be the first in each group");
    for ( var i = 0; i < groupCount; i++ ) {
      // create an array for each group
      sociogramGroups.push([]);
      console.log("Entries: " + sociogramJSON.length);
      console.log(JSON.stringify(sociogramJSON, null, 4));
      const randomEntryId = randomIntFromInterval(0, sociogramJSON.length);
      console.log(randomEntryId);
      const entry = sociogramJSON[randomEntryId];
      console.log(entry);
      assigned.push(entry); // keep track of assigned entries
      sociogramJSON.splice(randomEntryId,1);
      sociogramGroups[i].push(entry);
      console.log(entry.personName + " joins group " + i);
    }

    console.log("Interim");
    console.log(JSON.stringify(sociogramGroups, null, 5));

    while ( sociogramJSON.length > 0 ) {
      // if its the second person in each group, attempt to their favourite person
      if ( sociogramGroups[0].length === 1 ) {
        console.log("First entry");
        for ( var x = 0; x < groupCount; x++ ) {
          console.log("Group: " + x);
          console.log(JSON.stringify(sociogramGroups[x][0]));
          let favourite = findUserById(sociogramGroups[x][0].favourite, sociogramJSON);
          console.log( JSON.stringify(favourite) );
          if ( favourite.length == 1 ) {
            favourite = favourite[0];
            console.log("Favourite (" + favourite.personName + ") is available, add them to " + sociogramGroups[x][0].personName + "'s group");
            sociogramGroups[x].push(favourite);
            console.log("Removing " + favourite.personName + " from eligibility list");
            sociogramJSON.splice(getIndexByPersonId(favourite.personID, sociogramJSON), 1);
          } else { // grab another user from their selection list
            console.log("Favourite not available for selection, grab another from their list");
            let personToAdd = handleRandomUserSearch(sociogramGroups[x][0], sociogramJSON);
            sociogramGroups[x].push(personToAdd);
            sociogramJSON.splice(getIndexByPersonId(personToAdd.personID, sociogramJSON), 1);
          }
          
        }
      } else { // at least 2 in the group, find the next best match
        for ( var x = 0; x < groupCount; x++ ) {
          let mostRecentMember = sociogramGroups[x][sociogramGroups[x].length - 1];
          let secondMostRecentMember = sociogramGroups[x][sociogramGroups[x].length - 2];

          // attempt to add favourite first 
          let favourite = findUserById(mostRecentMember.favourite, sociogramJSON);
          if ( favourite.length == 1 ) {
            favourite = favourite[0];
            console.log("Favourite (" + favourite.personName + ") is available, add them to " + sociogramGroups[x][0].personName + "'s group");
            sociogramGroups[x].push(favourite);
            console.log("Removing " + favourite.personName + " from eligibility list");
            sociogramJSON.splice(getIndexByPersonId(favourite.personID, sociogramJSON), 1);
          } else {
            console.log("Couldn't select favourite for " + mostRecentMember.personName + ", try a mutual friend now");
            let excludeList = [];
            let foundUser = null;
            while ( foundUser === null ) {
              console.log("Finding mutual friend between " + mostRecentMember.personName + " and " + secondMostRecentMember.personName);
              console.log( mostRecentMember );
              console.log( secondMostRecentMember );
              let mutualFriend = getMutualPerson(mostRecentMember.selection, secondMostRecentMember.selection, excludeList);
              if ( mutualFriend !== null ) { // found a mutual friend
                let availableMutualFriend = findUserById(mutualFriend, sociogramJSON);
                if ( availableMutualFriend.length == 1 ) { // mutual friend is available to add to list
                  console.log("Found a mutual friend between " + mostRecentMember.personName + ", and " + secondMostRecentMember.personName);
                  availableMutualFriend = availableMutualFriend[0];
                  sociogramGroups[x].push(availableMutualFriend);
                  sociogramJSON.splice(getIndexByPersonId(availableMutualFriend.personID, sociogramJSON), 1);
                  foundUser = true;
                } else { // mutual friend not available, add to the exclude list and try again
                  excludeList.push( mutualFriend );
                }
              } else {
                let personToAdd = handleRandomUserSearch(mostRecentMember, sociogramJSON);
                if ( personToAdd !== null && personToAdd !== undefined ) {
                  sociogramGroups[x].push(personToAdd);
                  sociogramJSON.splice(getIndexByPersonId(personToAdd.personID, sociogramJSON), 1);
                  foundUser = true;
                } else {
                  console.log( "Any users left? " + sociogramJSON.length);
                  x = groupCount;
                  sociogramJSON = [];
                  break;
                }
                
              }
            }
          } 
        }
      }

      // pick user randomly
      for ( var entry of sociogramJSON ) {
        
      }

      console.log("Current groups:");
      console.log(JSON.stringify(sociogramGroups));
    }

    console.log("Group Assignments");
    console.log(JSON.stringify(sociogramGroups,null,5));
    //TODO: Group Size
    return sociogramGroups;
  }

  export const randomIntFromInterval = (min, max) => { // min and max included 
    return Math.floor(Math.random() * ((max - 1) - min + 1) + min);
  }

  export const findEntrySelectionsByPersonID = (personID, entries) => {
    //console.log("Searching for " + personID + " in " + JSON.stringify(entries) );
    for( var i = 0; i < entries.length; i++ )
      if( entries[i].person == personID ){
        //console.log("found.");
        return entries[i].socioData;
      }
  }

  export const findEntryFavouriteByPersonID = (personID, entries) => {
    for( var i = 0; i < entries.length; i++ )
      if( entries[i].person == personID )
        return entries[i].socioFavourite;
  }

  export const findUserById = (personId, data) => {
    return data.filter(
      function(data){ return data.personID == personId }
    );
  }

  export const getIndexByPersonId = ( personId, data) => {
    for ( var y = 0; y < data.length; y++ ) {
      if ( data[y].personID === personId ) {
        return y;
      }
    }
    return null;
  }

  export const getMutualPerson = ( selectionA, selectionB, excludeList ) =>  {
    if ( selectionA === null || selectionB === null ) { 
      return null;
    }
    for ( const a of selectionA ) {
      for ( const b of selectionB ) {
        if ( a === b && excludeList.indexOf(a) == -1 ) { // found a match that isn't excluded
          return a;
        }
      }
    }
    return null;
  }

  export const handleRandomUserSearch = (person, sociogramJSON) => {
    var foundUser = false;
    var count = 0;
    var totalInSelection = person.selection.length;
    let rejected = false;
    console.log("Total in selection: " + totalInSelection);
    while ( !foundUser && !rejected ) {
      console.log("Not found yet");
      // pick friend in order
      let friendInSelection = findUserById(person.selection[count], sociogramJSON);
      if ( friendInSelection.length == 1 ) { // user available for selection
        friendInSelection = friendInSelection[0];
        return friendInSelection;
      }
      count++;
      if ( count === totalInSelection ) {
        rejected = true;
      }
    }
    // could not find a good match
    if ( rejected ) {
      console.log("Rejected - adding random user between 0 and " + sociogramJSON.length);
      const randomEntryId = randomIntFromInterval(0, sociogramJSON.length);
      console.log("Random Number: " + randomEntryId);
      return sociogramJSON[randomEntryId];
    }
  }


